import { render, staticRenderFns } from "./CardPriceTable.vue?vue&type=template&id=5282e370&scoped=true&"
import script from "./CardPriceTable.vue?vue&type=script&lang=js&"
export * from "./CardPriceTable.vue?vue&type=script&lang=js&"
import style0 from "./CardPriceTable.vue?vue&type=style&index=0&id=5282e370&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5282e370",
  null
  
)

export default component.exports